import React from "react";
import { TabView, TabPanel } from "primereact/tabview";
import OrdersReportTab from "./OrdersReportTab";
import SalesReportTab from "./SalesReportTab";
import ItemReportTab from "./ItemReportTab";
import PurchaseReportTab from "./PurchaseReportTab";

export default function ReportsMain() {
  return (
    <div className="px-4">
      <div className="font-semibold text-black/50 text-xl ml-1 my-3">Reporting</div>

      <TabView>
        <TabPanel header="Orders Report">
          <OrdersReportTab />
        </TabPanel>
        <TabPanel header="Sales Report">
          <SalesReportTab />
        </TabPanel>
        <TabPanel header="Item Report">
          <ItemReportTab />
        </TabPanel>
        <TabPanel header="Purchase Report">
          <PurchaseReportTab />
        </TabPanel>
      </TabView>
    </div>
  );
}
